import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { DetectedProduct } from 'shared/src/api/types'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { Modal } from '../Modal'
import { IconButton } from '../IconButton'
import { MAIN_TITLE_STYLE } from '../styles'
import { Product } from './Product'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    paddingLeft: 21,
    paddingRight: 24,
    paddingTop: 19,
    height: '100dvh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  title: {
    ...MAIN_TITLE_STYLE,
    color: '#232323',
  },
  closeButton: {
    position: 'relative',
    right: -10,
  },
  closeButtonIcon: {
    color: '#90734F',
  },
  queueContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    paddingBottom: 24,
  },
  urlContainer: {
    backgroundColor: 'transparent',
    height: 64,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },
  textContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    overflow: 'hidden',
  },
  group: {
    marginBottom: 40,
  },
  productContainer: {
    backgroundColor: 'transparent',
    flexShrink: 0,
    paddingLeft: 0,
    paddingRight: 0,
    gap: 8,
  },
})

interface Props {
  groups: Array<Array<DetectedProduct>>
  onClose: () => void
  onProductChoose: (productId: number) => void
}

export const DetectedProductsModal: FC<Props> = flowMax(
  addDisplayName('DetectedProductsModal'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ groups, onClose, onProductChoose, classes, t }) => (
    <Modal containerClassName={classes.container}>
      <div className={classes.header}>
        <h1 className={classes.title}>
          {t('admin.post.detectedProductsTitle')}
        </h1>
        <IconButton
          onClick={onClose}
          name="close"
          className={classes.closeButton}
          iconClassName={classes.closeButtonIcon}
          addHitSlop
        />
      </div>
      <div className={classes.queueContainer}>
        {groups.map((products, index) => (
          <div className={classes.group} key={index}>
            {products.map(({ product, image }) => (
              <Product
                product={{ ...product, image }}
                onClick={() => onProductChoose(product.id)}
                className={classes.productContainer}
                key={product.id}
              />
            ))}
          </div>
        ))}
      </div>
    </Modal>
  )
)
